var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80823 12.6222L0.839844 6.65382L2.33194 5.16172L6.80823 9.63801L16.4152 0.0310059L17.9073 1.5231L6.80823 12.6222Z",
    fill: "#19B600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigth);
export default __webpack_public_path__ + "static/media/rigth.5ecaaa0f9544e9f13b125f132b22f09b.svg";
export { ForwardRef as ReactComponent };